import { formatOptionLabel } from "@src/core/engine/helpers/fieldDefinitions/getOptionsFieldDefinition";
import { PipeSeriesDefinitions } from "@src/core/engine/pipes/pipesRepository";
import { group } from "radashi";
import { useTranslation } from "react-i18next";
import { getSeriesDefaultPipe } from "../helpers/getSeriesDefaultPipe";
import { usePipeSeriesDataSuspense } from "../hooks/usePipeSeriesData";
import { usePipeSeriesForm } from "../hooks/usePipeSeriesForm";

type PipeSeriesSelectProps = {
  definitions: PipeSeriesDefinitions;
  form: ReturnType<typeof usePipeSeriesForm>["form"];
};

export function PipeSeriesSelect({ definitions, form }: PipeSeriesSelectProps) {
  const { t } = useTranslation("settings");
  const { customPipeSeries } = usePipeSeriesDataSuspense();
  const groupedSeries = group(definitions.pipeSeries.options, (option) =>
    option.custom ? "custom" : "default",
  );

  return (
    <form.AppField name="pipeSeries">
      {(pipeSeriesField) => (
        <pipeSeriesField.Select
          label={t("pipeSeries.pipeSeries")}
          onChange={(e) => {
            const pipe = getSeriesDefaultPipe(e.target.value, customPipeSeries);
            if (pipe) {
              form.setFieldValue("pipes", pipe);
            }
          }}
        >
          {groupedSeries.custom?.length ? (
            <optgroup label={t("pipeSeries.customSeries")}>
              {groupedSeries.custom.map((pipeSeries) => (
                <option key={pipeSeries.id} value={pipeSeries.id}>
                  {formatOptionLabel(pipeSeries, t)}{" "}
                  {pipeSeries.default ? t("pipeSeries.defaultOption") : ""}
                </option>
              ))}
            </optgroup>
          ) : null}

          <optgroup label={t("pipeSeries.pipeSeries")}>
            {groupedSeries.default?.map((pipeSeries) => (
              <option key={pipeSeries.id} value={pipeSeries.id}>
                {formatOptionLabel(pipeSeries, t)}{" "}
                {pipeSeries.default ? t("pipeSeries.defaultOption") : ""}
              </option>
            ))}
          </optgroup>
        </pipeSeriesField.Select>
      )}
    </form.AppField>
  );
}
